"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalhostFromObject = void 0;
var splitsParserFromSettings_1 = require("./splitsParser/splitsParserFromSettings");
var syncManagerOffline_1 = require("./syncManagerOffline");
// Singleton instance of the factory function for offline SyncManager from object (a.k.a. localhostFromObject)
// SDK instances instantiate their SyncManagers with the same factory
var localhostFromObject = (0, syncManagerOffline_1.syncManagerOfflineFactory)(splitsParserFromSettings_1.splitsParserFromSettingsFactory);
localhostFromObject.type = 'LocalhostFromObject';
function LocalhostFromObject() {
    return localhostFromObject;
}
exports.LocalhostFromObject = LocalhostFromObject;
